import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CoreService } from '../core.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedService } from '../../shared/shared.service';
import { MatSnackBar } from '@angular/material';
import { ResetPassword } from '../../shared/models/ResetPassword';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-recuperacion',
  templateUrl: './recuperacion.component.html',
  styleUrls: ['./recuperacion.component.css']
})
export class RecuperacionComponent implements OnInit {

  token: string;
  resetPasswordForm: FormGroup;
  username: string;

  constructor(public coreService: CoreService, private route: ActivatedRoute, private router: Router, private fb: FormBuilder
    , private sharedService: SharedService, public snackBar: MatSnackBar) {
    if (coreService.isLoggedIn()) {
      this.router.navigateByUrl('/menu');
    }
    this.coreService.titulo = "Recuperación de contraseña";
    this.coreService.activo = "recuperacion";
    this.resetPasswordForm = this.createForm(fb);
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.username = params['username'];
      this.resetPasswordForm.patchValue({ 'user': this.username });
      this.resetPasswordForm.get('user').disable();
    });
  }

  createForm(formBuilder: FormBuilder) {
    return formBuilder.group({
      user: ['', Validators.required],
      pass: ['', Validators.required],
      pass2: ['', Validators.required],
    }, {
      validator: this.passMatch('pass', 'pass2')
    });
  }

  passMatch(control: string, matchingControl: string) {
    return (fg: FormGroup) => {
      let c = fg.controls[control];
      let m = fg.controls[matchingControl];

      if (m.errors && !m.errors.notMatch) {
        return;
      }

      if (c.value !== m.value) {
        m.setErrors({ notMatch: true });
      } else {
        m.setErrors(null);
      }
    }
  }

  onPaste($event) {
    $event.preventDefault();
  }

  get matchError() {
    return this.resetPasswordForm.get('pass2').hasError('notMatch');
  }

  onSubmit() {
    this.sharedService.loadingBehaviorSubject.next(true);
    let user = new ResetPassword(this.resetPasswordForm.get('user').value, this.resetPasswordForm.get('pass').value, this.token);
    this.coreService.resetPassword(user).subscribe(response => {
      if (response.response_code > 0) {
        this.snackBar.open(response.message, '', { duration: 7500, panelClass: ["success-snackbar"] });
        this.router.navigate(['']);
      } else {
        this.snackBar.open(response.message, "x", { panelClass: ['error-snackbar'], duration: 2000 });
      }
      this.sharedService.loadingBehaviorSubject.next(false);
    });
  }

}
